module.exports = __webpack_public_path__ + "s/img/icon-able.a6ad076.png";


//////////////////
// WEBPACK FOOTER
// ./static/app-product-detail/assets/icon-able.png
// module id = 1069
// module chunks = 2